"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlchemyStyles = exports.alchemyHoc = void 0;
const react_1 = __importDefault(require("react"));
const GlobalStyles_1 = __importDefault(require("@mdigital/components/dist/alchemy/GlobalStyles"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const alchemyHoc = (Component) => function AlchemyHoc(props) {
    return (react_1.default.createElement(alchemy_ui_1.ThemeProvider, { theme: alchemy_ui_1.theme },
        react_1.default.createElement("div", { className: "alchemy" },
            react_1.default.createElement(Component, Object.assign({}, props)))));
};
exports.alchemyHoc = alchemyHoc;
// @ts-ignore
const AlchemyStyles = () => react_1.default.createElement(GlobalStyles_1.default, null);
exports.AlchemyStyles = AlchemyStyles;
